import api from "../libs/api";

export default {

  postWorkflow: (data) => {
    return api()
      .post("/own-workflows", data)
      .then(({ status, data }) => {
        if (status === 201) return data;
        throw new Error(`Failed with status: ${status}`);
      });
  },

  deleteWorkflow: (id) => {
    return api()
      .delete(`/own-workflows/${id}`)
      .then(({ status, data }) => {
        if (status === 200) return data;
        throw new Error(`Failed with status: ${status}`);
      });
  },

  updateWorkflow: (id, data) => {
    return api()
      .put(`/own-workflows/${id}`, data)
      .then(({ status, data }) => {
        if (status === 200) return data;
        throw new Error(`Failed with status: ${status}`);
      });
  },

  getWorkflowDetails: (id) => {
    return api()
      .get(`/own-workflows/${id}`)
      .then(({ status, data }) => {
        if (status === 200) return data.data;
        throw new Error(`Failed with status: ${status}`);
      });
  },

  // ✅ Pagination + filters
  getWorkflows: (params) => {
    return api()
      .get("/own-workflows", {
        params: {
          ...params,
          per_page: params?.per_page || 10,
        },
      })
      .then(({ status, data }) => {
        if (status === 200) return data;
        throw new Error(`Failed with status: ${status}`);
      });
  },

  // ✅ Correct update route
  updateWorkflowApprovers: (data) => {
    return api()
      .post("/update-own-initiated-workflow", data)
      .then(({ status, data }) => {
        if (status === 200) return data; // Laravel returning 200
        throw new Error(`Failed with status: ${status}`);
      });
  },
};